import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  card: {
    background: '#fff',
    border: '1px solid #EEF0F2',
    borderRadius: 12,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  actions: {
    display: 'flex',
    gap: 8,
    marginTop: 4
  },
  actionButton: {
    flex: 1
  },
  thumb: {
    width: '100%',
    height: 150,
    borderRadius: 8,
    objectFit: 'cover'
  },
  clickable: {
    cursor: 'pointer'
  },
  // Reserve the full two-line title height (2 × 24px base line-height) so the
  // badge/pages row and the buttons line up across cards, and vertically
  // center a single-line title within it.
  titleWrap: {
    minHeight: 48,
    display: 'flex',
    alignItems: 'center'
  },
  metaRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  }
});
